module.exports = __webpack_public_path__ + "assets/images/rideCenter-74c2b51b26a0591cb583ffee96774adb.webm";